"use client"

import { Button } from "@/components/ui";
import { ArrowRight, Crown, X } from "lucide-react";
import Link from "next/link";
import { useEffect, useState } from "react";

export const FreeTierBanner = () => {
   const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Check if the banner was dismissed recently
    const dismissedUntil = localStorage.getItem('freeBannerDismissedUntil');
    if (dismissedUntil) {
      const dismissDate = parseInt(dismissedUntil);
      if (Date.now() < dismissDate) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
        // If the dismissal period has expired, remove it from storage
        localStorage.removeItem('freeBannerDismissedUntil');
      }
    } else {
      setIsVisible(true);
    }
  }, []);
  
  const handleDismiss = () => {
    // Dismiss for one week (7 days)
    const oneWeekFromNow = Date.now() + (1 * 24 * 60 * 60 * 1000);
    localStorage.setItem('freeBannerDismissedUntil', oneWeekFromNow.toString());
    setIsVisible(false);
  };
  
  if (!isVisible) return null;

return (
    <div className="bg-gradient-to-r from-yellow-600 to-yellow-400 text-white px-4 py-3 relative">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <Crown className="h-5 w-5 text-yellow-300" />
          <span>
            You're using the <strong>Free Plan</strong>. Upgrade to Professional for more analyses, outreach emails, salary information and more!
          </span>
        </div>
        <div className="flex items-center space-x-2">
          <Link href="/subscribe">
            <Button size="sm" variant="secondary" className="">
              Upgrade Now
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
          <Button 
            onClick={handleDismiss} 
            size="sm" 
            variant="ghost" 
            className="text-white"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
)
}